class BuildingsService {
    constructor(
        $q,
        $http,
        Utility,
        $timeout,
        $interval,
        $rootScope,
        LocalStorageService,
        InternalLinksService,
        AuthenticationService,
        $sce
    ) {
        this.$q = $q;
        this.$http = $http;
        this.Utility = Utility;
        this.$timeout = $timeout;
        this.$interval = $interval;
        this.$rootScope = $rootScope;
        this.LocalStorageService = LocalStorageService;
        this.InternalLinksService = InternalLinksService;
        this.AuthenticationService = AuthenticationService;
        this.$sce = $sce;
        this.hasInitted = false;

        this.$rootScope.$on('user-logged-in-load-building-data', (event, params) => {
            this.init();
        });

        //this.init();
    }

    init() {
        this._await = undefined;
        this.buildingsData = {};

        this.deferred = this.$q.defer();
        this.intervalPromise = undefined;
        this.promise = this.deferred.promise;
        this.buildingsFeatures = null;

        const currentUser = this.AuthenticationService.currentUser();
        if (currentUser) {

            let currentlySelectedSchemeReference = this.LocalStorageService.retrieve('selectedBuildingRef');
            currentUser.BuildingProfiles = this.addBuildingImagesToArrayOfBuildingProfiles(currentUser.BuildingProfiles);

            let selectedProfile = undefined;

            if (!currentlySelectedSchemeReference) {
                selectedProfile = currentUser.BuildingProfiles && currentUser.BuildingProfiles.length > 0
                    ? currentUser.BuildingProfiles[0]
                    : undefined
            }
            else {
                selectedProfile = currentUser.BuildingProfiles && currentUser.BuildingProfiles.length > 0
                    ? currentUser.BuildingProfiles.find(x => x.SchemeReference == currentlySelectedSchemeReference)
                    : undefined
            }

            this.buildingsData = {
                allBuildings: currentUser.BuildingProfiles,
                selectedBuilding: selectedProfile
            };
        }

        if (currentUser && this.buildingsData['selectedBuilding']) {
            this.LocalStorageService.save(
                'selectedBuildingRef',
                this.buildingsData['selectedBuilding'].SchemeReference
            );
        }

        this.$rootScope.$on('building-reference-changed', (event, selectedBuildingRef) => {
            this.setSelectedBuildingRef(selectedBuildingRef);
        });

        this.hasInitted = true;
    }

    addBuildingImagesToArrayOfBuildingProfiles(arrayOfBuildingProfiles) {

        if (!!!arrayOfBuildingProfiles || arrayOfBuildingProfiles.length == 0) {
            return;
        }

        const buildings = arrayOfBuildingProfiles;
        const mapped = buildings.map(building => {
            const { SchemeReference: schemeReference } = building;
            const imgUrl = this.getTrustedBuildingImageUrl(schemeReference);
            return {
                imgUrl,
                ...building,
                isSelected: false
            };
        });

        return mapped;
    }

    getTrustedBuildingImageUrl(schemeReference) {
        const imgUrl = this.$sce.trustAsResourceUrl(
            `${PretorCDNAddress}/images/buildings/${schemeReference}/${schemeReference}.png`
        );
        const trustedUrl = this.$sce.valueOf(imgUrl);
        return trustedUrl;
    };

    loadBySchemeRef(schemeRef) {
        const currentUser = this.AuthenticationService.currentUser();
        if (currentUser) {
            this.buildingsData = {
                allBuildings: _.sortBy(currentUser.BuildingProfiles, [
                    (bp) => {
                        return bp.SchemeName;
                    }
                ]).map((buildingProfile) => {
                    buildingProfile.SchemeReference = buildingProfile.SchemeReference.trim();
                    return buildingProfile;
                }),
                selectedBuilding: undefined
            };

            const building = _.find(this.buildingsData.allBuildings, (buildingProfile) => {
                let found = false;
                found = buildingProfile.SchemeReference == schemeRef;
                return found;
            });
            if (building) {
                this.buildingsData.selectedBuilding = building;
                return this.$q.resolve(building);
            }
            return this.$q.reject('BuildingsService: Building information could not be found...');
        } else {
            return this.$q.reject('BuildingsService: User information could not be found...');
        }
    }

    setSelectedBuildingRef(buildingRef) {
        if (!this._await) {
            this._await = this.$timeout(() => {
                if (typeof buildingRef === 'object' && buildingRef.hasOwnProperty('SchemeReference'))
                    buildingRef = buildingRef.SchemeReference;

                if (this.buildingsData && this.buildingsData.allBuildings) {
                    const selectedBuilding = _.find(this.buildingsData.allBuildings, (building) => {
                        return building.SchemeReference === buildingRef;
                    });

                    if (
                        selectedBuilding &&
                        selectedBuilding.hasOwnProperty('SchemeReference') &&
                        buildingRef !== selectedBuilding.SchemeReference
                    ) {
                        this.buildingsData.selectedBuilding = selectedBuilding;
                    }

                    this._await = undefined;
                } else {
                    this.promise.then((results) => {
                        const selectedBuilding = _.find(this.buildingsData.allBuildings, (building) => {
                            return building.SchemeReference === buildingRef;
                        });

                        if (buildingRef !== selectedBuilding.SchemeReference)
                            this.buildingsData.selectedBuilding = selectedBuilding;
                        this._await = undefined;
                    });
                }
            }, this.Utility.apiRetry.value / 2);
        }
    }

    getSelectedBuildingRef() {
        let selectedBuildingRef = this.LocalStorageService.retrieve('selectedBuildingRef');

        if (selectedBuildingRef && typeof selectedBuildingRef === 'object') {
            selectedBuildingRef = selectedBuildingRef.SchemeReference;
        }

        if (!selectedBuildingRef) {
            let selectedBuildingRefQueryString = this.Utility.QueryString('DBRef');
            if (selectedBuildingRefQueryString) {
                this.selectedBuildingRef = selectedBuildingRefQueryString.toUpperCase();
            }
        }

        return selectedBuildingRef;
    }

    //TODO: THis must be called by the 'My Profile' Ctrl
    async getSelectedBuildingReferenceObject() {
        const deferred = this.$q.defer();
        const promise = deferred.promise;

        let selectedBuildingObj;
        let selectedBuilding = this.LocalStorageService.retrieve('selectedBuildingRef');
        if (!selectedBuilding) {
            let selectedBuildingRefQueryString = this.Utility.QueryString('DBRef');
            if (selectedBuildingRefQueryString) {
                this.selectedBuildingRef = selectedBuildingRefQueryString.toUpperCase();
            }
        }

        if (selectedBuilding) {
            if (typeof selectedBuilding === 'object') {
                return deferred.resolve(selectedBuilding);
            }
        }

        let userProfile = this.LocalStorageService.retrieve('userProfile');

        if (!userProfile) {
            const awaitedPromise = await this.$interval(
                () => {
                    userProfile = this.LocalStorageService.retrieve('userProfile');
                    if (userProfile) {
                        this.$interval.cancel(awaitedPromise);
                    }
                },
                350,
                1
            );
        }


        selectedBuildingObj = userProfile.BuildingProfiles.find((buildingProf) => {
            const buildingRef = buildingProf.SchemeReference.toLowerCase().trim();
            if (buildingRef === selectedBuilding.toLowerCase().trim()) {
                return true;
            }
        });

        if (!selectedBuildingObj) {
            selectedBuilding = await this.loadBySchemeRef(selectedBuilding);
        }

        if (!selectedBuilding) {
            return deferred.reject(`Error while retrieving 'Selected Building Reference'`);
        }

        //return selectedBuildingObj;
        return promise;
    }

    async getBuildingFeatureSettings(schemeRef) {
        let promise, promiseHandler;

        try {
            promise = new Promise((resolve, reject) => {
                promiseHandler = {
                    reject,
                    resolve
                };
            });

            let url = await this.InternalLinksService.getLink('DashboardFeature');
            if (!url) {
                await this.InternalLinksService.getLinks('api/settings/links');
                url = await this.InternalLinksService.getLink('DashboardFeature');
            }

            const headers = this.Utility.basicHeaders;

            url = `${url.replace('{schemeRef}', schemeRef)}`;

            if (!!!headers) {
                throw new Error(`Could not load headers for request: ${url}`);
            }

            const results = await this.$http.get(url, headers);

            const { Data: data, WasSuccessful: wasSuccessful } = results.data;

            if (wasSuccessful) {
                this.buildingsFeatures = {
                    ...this.buildingsFeatures,
                    [schemeRef.toUpperCase().trim()]: data
                };

                this.LocalStorageService.save('buildingsFeatures', this.buildingsFeatures);
                this.$timeout(() => promiseHandler.resolve(data));
            } else {
                throw new Error(`Error while loading the Dashboard feature flag for ${schemeRef}`);
            }
        } catch (error) {
            if (this.buildingsFeatures && `${schemeRef}` in this.buildingsFeatures) {
                delete this.buildingsFeatures[schemeRef];
            }

            this.$timeout(() => promiseHandler.reject(error));
        }

        return promise;
    }
}

export default /* @ngInject */ (
    $q,
    $http,
    Utility,
    $timeout,
    $interval,
    $rootScope,
    LocalStorageService,
    InternalLinksService,
    AuthenticationService,
    $sce
) =>
    new BuildingsService(
        $q,
        $http,
        Utility,
        $timeout,
        $interval,
        $rootScope,
        LocalStorageService,
        InternalLinksService,
        AuthenticationService,
        $sce
    );
